import { render } from "./singleComment.vue?vue&type=template&id=51a4f976"
import script from "./singleComment.vue?vue&type=script&lang=js"
export * from "./singleComment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__